import {
    dataURLtoFile,
    RaikoGridOneColumn,
    RaikoGridTwoColumn,
    RaikoSimpleInputOutlined,
    RaikoSectionContainer,
    RaikoSimpleMultiLineInputOutlined,
    RaikoHtmlTextEditor,
    RaikoLabel,
    RaikoFlexAlignEnd,
    RaikoButtonPrimary,
    showWarningMessage, showSuccessMessage, showErrorMessage
} from "@moeindal/base-raiko-panel-components";
import UploadThumbnail from "../../component/uploadThumbnail/UploadThumbnail";
import React, {useState} from "react";
import {VideoService} from "../../serverService/videos/VideoService";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {css} from "@emotion/css";
import RaikoAparatVideoSelector from "../../raikoComponents/raikoCustomBlogEditor/aparatVideo/RaikoAparatVideoSelector";
import RaikoEditorHtmlEditor from "../../raikoComponents/raikoEditor/htmlEditor/RaikoEditorHtmlEditor";
import CustomHtmlTextEditor from "../../component/magazine/CustomHtmlTextEditor";
import RaikoTextEditor from "../../raikoComponents/raikoTextEditor/RaikoTextEditor";
import {stringIsEmpty} from "../../util/VariableChecker";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";
import AdvanceRichEditor from "../../raikoComponents/raikoEditor/raikoRichEditor/AdvanceRichEditor";

export default function AddNewVideos({handleAddVideoToList}) {

    const loading = new LoadingHelper(useLoadingDispatcher())

    const [photoFile, setPhotoFile] = useState(null)
    const [photoUrl, setPhotoUrl] = useState("");
    const [thumbnailLoadingState, setThumbnailLoadingState] = useState(false);

    const [title, setTitle] = useState("");
    const [writerName, setWriterName] = useState("");
    const [aparatLink, setAparatLink] = useState("");
    const [shortDescription, setShortDescription] = useState("");
    const [description, setDescription] = useState("")

    const service = new VideoService()

    const handleSelectImage = (imgSrc, fileName) => {
        const imageFile = dataURLtoFile(imgSrc, fileName)
        setPhotoUrl(imgSrc)
        setPhotoFile(imageFile)
    }

    function handleAddNewVideo() {
        if (checkFields()) {
            loading.show()
            service.addNewClip(
                photoFile,
                title,
                writerName,
                aparatLink,
                shortDescription,
                description
            ).then(response => {
                showSuccessMessage("کلیپ جدید با موفقیت افزوده شد.")
                handleAddVideoToList(response)
            }).catch(reason => {
                showErrorMessage(detectServerErrorMessage(reason))
            }).finally(_ => {
                loading.hide()
            })
        }
    }

    function checkFields() {
        let state = false
        let message

        if (stringIsEmpty(title))
            message = "لطفا عنوان کلیپ را به درستی وارد نمایید."
        else if (stringIsEmpty(writerName))
            message = "لطفا نویسنده کلیپ را به درستی وارد نمایید."
        else if (stringIsEmpty(aparatLink))
            message = "لطفا لینک آپارات را به درستی وارد نمایید."
        else if (photoFile === null)
            message = "لطفا تصویر شاخص را انتخاب نمایید."
        else if (stringIsEmpty(shortDescription))
            message = "لطفا توضیحات کوتاه کلیپ را به درستی وارد نمایید."
        else if (stringIsEmpty(description) || description === "<p><br></p>")
            message = "لطفا توضیحات کلیپ را به درستی وارد نمایید."
        else
            state = true

        if (message)
            showWarningMessage(message)

        return state

    }

    return (
        <RaikoGridOneColumn className={css`padding: 0 1rem 1rem 1rem`}>
            <RaikoGridTwoColumn>
                <RaikoSimpleInputOutlined
                    labelText={"عنوان"}
                    value={title}
                    setValue={setTitle}
                />
                <RaikoSimpleInputOutlined
                    labelText={"نویسنده"}
                    value={writerName}
                    setValue={setWriterName}
                />
            </RaikoGridTwoColumn>
            <RaikoAparatVideoSelector value={aparatLink} setVideo={setAparatLink}/>
            <RaikoSectionContainer
                title={"تصویر شاخص"}
            >
                <UploadThumbnail
                    avatarFile={photoUrl}
                    updateAvatar={handleSelectImage}
                    loading={thumbnailLoadingState}
                />
            </RaikoSectionContainer>
            <RaikoSimpleMultiLineInputOutlined
                labelText={"توضیحات کوتاه"}
                value={shortDescription}
                setValue={setShortDescription}
            />
            <RaikoLabel text={"توضیحات"}/>
            <AdvanceRichEditor
                text={description}
                setText={setDescription}
            />
            <RaikoFlexAlignEnd
            >
                <RaikoButtonPrimary label={"افزودن"} onClick={handleAddNewVideo}/>
            </RaikoFlexAlignEnd>

        </RaikoGridOneColumn>
    )
}
